var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "folder download") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    fill: "#ffffff",
    stroke: "#ffffff"
  }, /*#__PURE__*/React.createElement("line", {
    "data-cap": "butt",
    "data-color": "color-2",
    x1: 12,
    y1: 21,
    x2: 12,
    y2: 11,
    fill: "none",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    "data-color": "color-2",
    points: "16 17 12 21 8 17",
    fill: "none",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,22H3a2,2,0,0,1-2-2V2H9l3,4H23V20a2,2,0,0,1-2,2H17",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderDownload);
export default __webpack_public_path__ + "static/media/folder-download.43b0ccdb.svg";
export { ForwardRef as ReactComponent };